import React, { Component } from "react";
import { auth } from '../../firebase/config'
import {
    MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavItem, MDBNavLink, MDBNavbarToggler, MDBCollapse, MDBIcon
} from "mdbreact";
import { Consumer } from '../../contextProvider/ContextProvider'


class NavbarPage extends Component {
    state = {
        isOpen: false
    };

    toggleCollapse = () => {
        this.setState({ isOpen: !this.state.isOpen });
    }
    logout = () => {
        auth.signOut()
        localStorage.removeItem('uid')
    }

    render() {
        return (
            <Consumer>

                {(context) => {
                    let color = context.state.themeStatus ? '#33b5e5' : '#d83434'
                    return (
                        <MDBNavbar style={{ background: color }} dark expand="md">
                            <MDBNavbarBrand>
                            </MDBNavbarBrand>
                            <MDBNavbarToggler onClick={this.toggleCollapse} />
                            <MDBCollapse id="navbarCollapse3" isOpen={this.state.isOpen} navbar>
                                <MDBNavbarNav left>
                                    <MDBNavItem active>
                                        <MDBNavLink to="/"><strong> Vaults</strong></MDBNavLink>
                                    </MDBNavItem>
                                </MDBNavbarNav>
                                <MDBNavbarNav >
                                    <div className="custom-control custom-switch">
                                        <input onChange={context.onChangeTheme} onClick={context.toggleTheme} checked={context.state.themeStatus} type="checkbox" className="custom-control-input" id="customSwitch1" />
                                        <label className="custom-control-label text-white" htmlFor="customSwitch1">Toggle this to switch theme</label>
                                    </div>
                                </MDBNavbarNav>
                                <MDBNavbarNav right>
                                    <MDBNavItem active>
                                        <MDBNavLink onClick={this.logout} to="#!">Logout</MDBNavLink>
                                    </MDBNavItem>
                                    <MDBNavItem>
                                        <MDBNavLink className="waves-effect waves-light" to="#!">
                                            <MDBIcon icon="user" />
                                        </MDBNavLink>
                                    </MDBNavItem>
                                    <MDBNavItem >
                                        <p style={{ margin: 0 }} className='mt-2 text-white' >
                                            <strong>
                                                {this.props.name}
                                            </strong>
                                        </p>
                                    </MDBNavItem>
                                </MDBNavbarNav>
                            </MDBCollapse>
                        </MDBNavbar>
                    )
                }}

            </Consumer>
        );
    }
}

export default NavbarPage;